import React, { useState } from 'react';
import { collection, getDocs, query, where, writeBatch, doc } from 'firebase/firestore';
import { db } from '../firebase';

function AbaManutencaoLojas({ somenteConsulta = false }) {
  const [lojaAntiga, setLojaAntiga] = useState('');
  const [lojaNova, setLojaNova] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');

  const padronizarLoja = async (e) => {
    e.preventDefault();

    if (!lojaAntiga || !lojaNova || !cidade || !estado) {
      alert('Por favor, preencha todos os campos.');
      return;
    }

    if (!window.confirm(`Tem certeza que deseja alterar todas as ofertas de "${lojaAntiga}" para "${lojaNova}" em ${cidade} - ${estado}?`)) {
      return;
    }

    setLoading(true);
    setMensagem('Buscando e atualizando as postagens. Aguarde um instante...');

    try {
      const consultas = await Promise.all([
        getDocs(query(collection(db, 'promocoes'), where('local', '==', lojaAntiga))),
        getDocs(query(collection(db, 'promocoes'), where('nome_usuario', '==', lojaAntiga))),
      ]);

      const documentosMap = new Map();
      consultas.forEach((snapshot) => {
        snapshot.forEach((documento) => {
          documentosMap.set(documento.id, documento);
        });
      });

      if (documentosMap.size === 0) {
        setMensagem(`Nenhuma postagem foi encontrada com o nome "${lojaAntiga}".`);
        setLoading(false);
        return;
      }

      const batch = writeBatch(db);
      let count = 0;

      documentosMap.forEach((documento) => {
        const docRef = doc(db, 'promocoes', documento.id);
        batch.update(docRef, {
          local: lojaNova,
          nome_usuario: lojaNova,
          cidade_oferta: cidade,
          estado_oferta: estado,
        });
        count++;
      });

      await batch.commit();

      setMensagem(`${count} postagens foram corrigidas com sucesso para "${lojaNova}".`);
      setLojaAntiga('');
      setLojaNova('');
      setCidade('');
      setEstado('');
    } catch (error) {
      console.error('Erro ao padronizar loja:', error);
      setMensagem('Erro ao atualizar as postagens. Verifique o console e tente novamente.');
    }

    setLoading(false);
  };

  const mensagemComErro = /erro|nenhuma/i.test(mensagem);

  return (
    <div className="routine-panel">
      <div className="routine-grid-2" style={{ marginBottom: '18px' }}>
        <div className="routine-callout routine-callout--warm">
          <p className="routine-callout__eyebrow">Quando usar</p>
          <h4 className="routine-callout__title">Ajuste cirúrgico na base</h4>
          <p className="routine-callout__text">
            Ideal para unificar variações do mesmo nome comercial e manter cidade e estado preenchidos corretamente.
          </p>
        </div>

        <div className="routine-callout">
          <p className="routine-callout__eyebrow">Importante</p>
          <h4 className="routine-callout__title">Revise antes de confirmar</h4>
          <p className="routine-callout__text">
            Esta manutenção atualiza em lote o nome exibido da loja e a base de cidade/UF das postagens encontradas.
          </p>
        </div>
      </div>

      <div className="routine-surface">
        <form onSubmit={padronizarLoja} className="admin-stack">
          <div className="routine-field routine-field--grow">
            <label className="routine-label">Nome incorreto no sistema</label>
            <input
              type="text"
              value={lojaAntiga}
              onChange={(e) => setLojaAntiga(e.target.value)}
              placeholder="Ex: Brasil atacadista"
              className="routine-input"
              disabled={somenteConsulta}
            />
          </div>

          <div className="admin-form-divider" />

          <div className="routine-field routine-field--grow">
            <label className="routine-label">Nome novo padronizado</label>
            <input
              type="text"
              value={lojaNova}
              onChange={(e) => setLojaNova(e.target.value)}
              placeholder="Ex: Brasil Atacadista"
              className="routine-input"
              disabled={somenteConsulta}
            />
          </div>

          <div className="admin-grid-2">
            <div className="routine-field">
              <label className="routine-label">Cidade correta</label>
              <input
                type="text"
                value={cidade}
                onChange={(e) => setCidade(e.target.value)}
                placeholder="Ex: Rio do Sul"
                className="routine-input"
                disabled={somenteConsulta}
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Estado (UF)</label>
              <input
                type="text"
                value={estado}
                onChange={(e) => setEstado(e.target.value.toUpperCase())}
                placeholder="Ex: SC"
                maxLength={2}
                className="routine-input"
                disabled={somenteConsulta}
              />
            </div>
          </div>

          <div className="routine-actions">
            <button type="submit" disabled={somenteConsulta || loading} className="routine-btn routine-btn--primary">
              {loading ? 'Processando...' : 'Corrigir e padronizar'}
            </button>
          </div>
        </form>

        {mensagem && (
          <div className={`routine-callout ${mensagemComErro ? 'routine-callout--danger' : 'routine-callout--success'} admin-message-surface`}>
            <p className="routine-callout__text" style={{ margin: 0, fontWeight: 700 }}>
              {mensagem}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AbaManutencaoLojas;
